import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

export const CariadEducationIcon = () => {
  const theme = useTheme();
  const { mode } = theme.palette;
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="CARIAD_Education_NC_RGB">
        <path
          id="Vector"
          d="M27.209 13.143L16.1312 9.11104C16.0465 9.08032 15.9536 9.08032 15.8688 9.11104L4.79107 13.143C4.63939 13.1981 4.53827 13.3427 4.53827 13.504C4.53827 13.6653 4.63939 13.8099 4.79107 13.865L9.47203 15.5686V20.489C9.47203 20.6502 9.57315 20.7949 9.72483 20.8499L14.8179 22.704C15.1994 22.8429 15.5994 22.912 16 22.912C16.4007 22.912 16.8007 22.8429 17.1821 22.704L22.2752 20.8499C22.3493 20.823 22.4133 20.7739 22.4585 20.7093C22.5037 20.6447 22.528 20.5678 22.528 20.489V17.92H21.76V20.2202L16.9197 21.9821C16.3258 22.1978 15.6749 22.1978 15.081 21.9821L10.24 20.2202V15.8483L15.8688 17.897C15.9536 17.9276 16.0465 17.9276 16.1312 17.897L24.448 14.8698V20.992H24.2784C24.0922 20.992 23.9328 21.1258 23.9002 21.3094L23.4938 23.6134C23.484 23.6687 23.4864 23.7254 23.5009 23.7796C23.5154 23.8337 23.5416 23.8841 23.5777 23.9271C23.6137 23.97 23.6588 24.0045 23.7097 24.0282C23.7605 24.0519 23.8159 24.0641 23.872 24.064H25.792C25.8481 24.0641 25.9035 24.0519 25.9544 24.0282C26.0053 24.0045 26.0503 23.97 26.0864 23.9271C26.1224 23.8841 26.1486 23.8337 26.1631 23.7796C26.1776 23.7254 26.1801 23.6687 26.1703 23.6134L25.7639 21.3094C25.7312 21.1258 25.5719 20.992 25.3856 20.992H25.216V14.5901L27.209 13.865C27.3607 13.8099 27.4618 13.6653 27.4618 13.504C27.4618 13.3427 27.3607 13.1981 27.209 13.143ZM24.3296 23.296L24.6003 21.76H25.0637L25.3344 23.296H24.3296ZM16 17.1277L6.04483 13.504L16 9.88032L25.9552 13.504L16 17.1277Z"
          fill={mode === 'dark' ? '#fff' : '#757575'}
        />
      </g>
    </SvgIcon>
  );
};
